import { h, Ref, useRef, ValueOrCalculator } from '@lukekaalim/act';

export const useExternalRef = <T>(externalRef: void | null | Ref<T>, initialInternal: ValueOrCalculator<T>): Ref<T> => {
  const internal = useRef<T>(initialInternal);

  if (externalRef)
    return externalRef;
  return internal;
}
